import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NS, PROFILE_KEYS } from '../../../i18n/constants/keys';
import { translateRole } from '../../../i18n/helpers/translateRole';

interface IProfilePageHeaderProps {
  userRole: string;
}

export const ProfilePageHeader = ({ userRole }: IProfilePageHeaderProps) => {
  const { t } = useTranslation(NS.profile);
  const { t: tNav } = useTranslation(NS.navbarMenus);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1.5}
      alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
      justifyContent="space-between"
      sx={{ mb: { xs: 2.5, sm: 3 } }}
    >
      <Box>
        <Typography variant="h1">
          {t(PROFILE_KEYS.page.title)}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t(PROFILE_KEYS.page.subtitle)}
        </Typography>
      </Box>
      <Chip label={translateRole(tNav, userRole)} color="primary" size="small" sx={{ fontWeight: 700 }} />
    </Stack>
  );
};
